import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import InactivityGuard from './components/auth/InactivityGuard';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import InvestorDetailPage from './pages/InvestorDetailPage';
import Products from './pages/Products';
import Investment from './pages/Investment';
import AmortizationSchedule from './pages/AmortizationSchedule';
import SeguimientoCra from './pages/SeguimientoCra';
import InmuebleTickets from './pages/InmuebleTickets';
import CarteraRevalorizacion from './pages/CarteraRevalorizacion';
import NotFound from './pages/NotFound';
import './styles/App.css';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ToastProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <InactivityGuard />
          <Routes>
            {/* Rutas públicas */}
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ResetPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Rutas protegidas */}
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<Layout />}>
                <Route index element={<Dashboard />} />
                <Route path="usuarios" element={<Users />} />
                <Route path="usuarios/:id" element={<InvestorDetailPage />} />
                <Route path="productos" element={<Products />} />
                <Route path="inversiones" element={<Investment />} />
                <Route path="cuadro-amortizacion" element={<AmortizationSchedule />} />
                <Route path="seguimiento-cra" element={<SeguimientoCra />} />
                <Route path="seguimiento-cra/inmuebles/:inmuebleId/tickets" element={<InmuebleTickets />} />
                <Route path="cartera-revalorizacion" element={<CarteraRevalorizacion />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Route>

            {/* Ruta 404 fuera de layout */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
